import MallDialog from "@/components/mall-dialog/index.vue"
import GoodsDetailDialogContent from "./components/GoodsDetailDialogContent.vue"
import { apiBuyProduct } from "@/models/mall"

export default {
    components: {
        MallDialog,
        GoodsDetailDialogContent,
    },
    data() {
        return {
            goodsDetailVisible: false,
            currentGoods: {},
        }
    },
    methods: {
        showGoodsDetail(item) {
            this.currentGoods = item
            this.goodsDetailVisible = true
        },
        async buyGoods() {
            try {
                if (!this.currentGoods.id) {
                    throw new Error('商品不存在')
                }
                this.$lLoading.show()
                await apiBuyProduct({
                    productId: this.currentGoods.id,
                    num: 1,
                })
                this.$lPrompt({
                    message: '购买成功',
                })
            } catch (error) {
                console.error(error)
                this.$lPrompt({
                    message: error.msg,
                })
            } finally {
                this.$lLoading.hide()
            }
        },
    },
}